import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Badge } from '@/components/ui/Badge';
import { applicationsApi } from '@/api/applications';
import { formatDate } from '@/utils/format';

export function ApplicationsPage() {
  const { t } = useTranslation();
  const apps = useQuery({ queryKey: ['applications'], queryFn: applicationsApi.list });

  if (apps.isLoading) return <Spinner />;

  return (
    <Card title={t('applications.my_applications')}>
      {apps.data && apps.data.length > 0 ? (
        <ul className="divide-y divide-slate-100">
          {apps.data.map((a) => (
            <li key={a.id} className="flex items-center justify-between py-3 text-sm">
              <div>
                <p className="font-medium">#{a.id}</p>
                <p className="text-xs text-slate-500">{formatDate(a.created_at)}</p>
              </div>
              <Badge
                tone={
                  a.status === 'approved' ? 'success' : a.status === 'rejected' ? 'danger' : 'info'
                }
              >
                {t(`applications.status.${a.status}`)}
              </Badge>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-slate-500">{t('web.empty.no_data')}</p>
      )}
    </Card>
  );
}
